import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class SwitchTab extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        tabSwitch: PropTypes.func,
    };

    state = {
        type: this.props.content[0].tag,
    };

    onClick = tag => {
        const { type } = this.state;

        if (tag === type) return;
        this.setState({ type: tag });
        this.props.tabSwitch(tag);
    };

    render() {
        const { type } = this.state;
        const { content } = this.props;
        const nav = content;

        return (
            <div className={styles.nav}>
                <ul>
                    {nav.map(item => (
                        <li
                            key={item.tag}
                            className={type === item.tag || nav.length === 1 ? styles.li_checked : ''}
                            onClick={() => this.onClick(item.tag)}>
                            <span className={type === item.tag || nav.length === 1 ? styles.span_checked : ''}>
                                {item.name}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(SwitchTab);
